import { render, staticRenderFns } from "./BusinessContactCategoryCreate.vue?vue&type=template&id=6a1c6481"
import script from "./BusinessContactCategoryCreate.vue?vue&type=script&lang=js"
export * from "./BusinessContactCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports